import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { saveUserConfirmation, handleEmailConfirmation } from "./thunk";

export interface UserConfirmationState {
  error: string | null;
  status: "idle" | "fetching" | "saving";
  isOtpVerifiedSuccessfully: boolean;
  isEmailConfirmed: boolean;
}

const initialState: UserConfirmationState = {
  error: null,
  status: "idle",
  isOtpVerifiedSuccessfully: false,
  isEmailConfirmed: false
};

export const userConfirmationSlice = createSlice({
  name: "userConfirmation",
  initialState,
  reducers: {
    resetOtpError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[userConfirmationSlice.name]
        };
      })
      .addCase(saveUserConfirmation.pending, (state) => {
        state.status = "saving";
      })
      .addCase(saveUserConfirmation.fulfilled, (state) => {
        state.status = "idle";
        state.isOtpVerifiedSuccessfully = true;
      })
      .addCase(saveUserConfirmation.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
        state.isOtpVerifiedSuccessfully = false;
      })
      .addCase(handleEmailConfirmation.pending, (state) => {
        state.status = "saving";
      })
      .addCase(handleEmailConfirmation.fulfilled, (state) => {
        state.status = "idle";
        state.isEmailConfirmed = true;
      })
      .addCase(handleEmailConfirmation.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});

export const { resetOtpError } = userConfirmationSlice.actions;
